import React, { useEffect } from 'react'
import FormRegister from '@/components/organisms/FormRegister/FormRegister'
import { RegisterProvider } from '@/context'
import Cookies from 'js-cookie'
import { TOKEN } from '@/utils/constants'
import { encrypt } from '@/utils'
import { sweetError } from '@/utils/sweetalert2'
import { Main } from '@/components/templates/Guest'
import axios from 'axios'

const Index = ({ tokenGuest }) => {
  useEffect(() => {
    // console.log('tokenGuest', tokenGuest)
    if (!tokenGuest.error && tokenGuest.token) {
      Cookies.set(TOKEN, encrypt(tokenGuest.token))
    } else {
      sweetError('', tokenGuest.message)
    }
  }, [tokenGuest])

  return (
    <Main title='Registro'>
      <RegisterProvider>
        <FormRegister />
      </RegisterProvider>
    </Main>
  )
}

export async function getServerSideProps () {
  try {
    const baseURL = process.env.API_PASSPORT_URL
    const clientId = process.env.CLIENT_ID
    const clientSecret = process.env.CLIENT_SECRET
    
    // Validar que las variables de entorno existan
    if (!baseURL || !clientId || !clientSecret) {
      console.error('❌ Variables de entorno faltantes:', {
        API_PASSPORT_URL: !!baseURL,
        CLIENT_ID: !!clientId,
        CLIENT_SECRET: !!clientSecret
      })
      return {
        props: {
          tokenGuest: {
            error: true,
            message: 'Error de configuración del servidor. Por favor, contacte al administrador.'
          }
        }
      }
    }
    
    const formData = new FormData()
    formData.append('grant_type', 'client_credentials')
    formData.append('client_id', clientId)
    formData.append('client_secret', clientSecret)
    
    const response = await axios.post(`${baseURL}/oauth/token`, formData, {
      timeout: 10000,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    
    const { access_token: accessToken } = response.data
    
    if (!accessToken) {
      return {
        props: {
          tokenGuest: {
            error: true,
            message: 'No se pudo obtener el token de acceso. Por favor, intente nuevamente.'
          }
        }
      }
    }
    
    return {
      props: {
        tokenGuest: {
          error: false,
          token: accessToken
        }
      }
    }
  } catch (error) {
    console.error('❌ Error obteniendo token de invitado:', error)
    
    let errorMessage = 'Error al conectar con el servidor. Por favor, intente nuevamente.'
    
    if (error.response) {
      const status = error.response.status
      
      if (status === 401) {
        errorMessage = 'Credenciales inválidas. Por favor, contacte al administrador del sistema.'
      } else if (status === 404) {
        errorMessage = 'Servicio no encontrado. Por favor, contacte al administrador.'
      } else if (status >= 500) {
        errorMessage = 'Error del servidor. Por favor, intente más tarde.'
      } else {
        errorMessage = error.response.data?.message || error.response.data?.error || `Error ${status}: ${error.response.statusText}`
      }
    } else if (error.request) {
      errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión a internet.'
    } else if (error.code === 'ECONNABORTED') {
      errorMessage = 'Tiempo de espera agotado. Por favor, intente nuevamente.'
    }
    
    return {
      props: {
        tokenGuest: {
          error: true,
          message: errorMessage
        }
      }
    }
  }
}

export default Index
